import type { TierInfo } from 'src/components/ui/SteppedTierSlider';
import { colours } from 'src/constants/colours';

export const consumptionTiers: TierInfo[] = [
    { color: '#00B81D', textColor: colours.white.main },
    { color: '#9FD700', textColor: colours.white.main },
    { color: '#E8DE00', textColor: colours.white.main },
    { color: '#FFC700', textColor: colours.white.main },
    { color: '#FF9900', textColor: colours.white.main },
    { color: '#FF5C00', textColor: colours.white.main },
    { color: '#D80000', textColor: colours.white.main },
];

export const emissionsTiers: TierInfo[] = [
    { color: '#ECF5FD', textColor: colours.black.main },
    { color: '#D1E9FF', textColor: colours.black.main },
    { color: '#AFD6F9', textColor: colours.black.main },
    { color: '#88C4FB', textColor: colours.black.main },
    { color: '#63B1F9', textColor: colours.white.main },
    { color: '#3295F0', textColor: colours.white.main },
    { color: '#0072DA', textColor: colours.white.main },
];
